module.exports = __webpack_public_path__ + "media/images/emblems/Schmitten_GR_wappen-b32e84594bc40ea2ae9a49b0c3be6d3d.svg";